import React, { useContext } from "react";
import { List, ListItem, Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { LegalEntityAvatar, PersonAvatar, Tag } from "../Snippet";
import { Anchor, Text } from "../Typography";
import { Input } from "../FormElements";
import { useFormatter } from "src/mtska-frontend-app-component/utils";
import { AppContext } from "src/mtska-frontend-app-scaffolding";
import Dashboard from "src/mtska-frontend-modules/modules/Car/components/Dashboard";

const dataProviderName = 'cars/car';

const InfoHeaderLegalEntity = ({ view, item, control }) => {
    const { appConfiguration } = useContext(AppContext);
    const { t } = useTranslation();
    const { formatDate, formatDistance } = useFormatter();

    return (
        <Box className={"info-header info-header-" + view}>
            <Box className={"info-wrapper"}>
                <Box className="info-summary-external">
                    {
                        item?.owner && (
                            <Text icon="faUserTie" className="info-contract">{item?.owner}</Text>
                        )
                    }
                    {
                        item?.type && (
                            <Text icon="faCircleUser" className="info-contract">{t(item?.type)}</Text>

                        )
                    }
                    {
                        item?.supplier_type && (
                            <Text icon="faTruck" className="info-contract">{t(item?.supplier_type)}</Text>
                        )
                    }
                    {
                        item?.updated_at && (
                            <Text icon="faPen" className="info-contract">{formatDate(item?.updated_at)}</Text>
                        )
                    }
                </Box>
                <Box className="info-name">
                    <LegalEntityAvatar name={item?.name} url={item?.logo?.url} withname={true} />
                </Box>
                {appConfiguration.dashboard.view == 'ConsecutionSales' && (
                    <Dashboard
                        dataProviderName={dataProviderName}
                        filters={{ items: [{ field: '_related_legalEntity_name', operator: 'equals', value: item?.name }] }}
                        reportVisibleDefault={true}
                        reportTitleDefault={"Business Review"}
                    />
                )}
            </Box>
        </Box>
    )
}

export default InfoHeaderLegalEntity;